// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9a8a8b21","393":"d5fb43c2","447":"f8cf472f","453":"8a65859e","455":"f6db8917","457":"f96ed323","484":"778a3886","551":"7b85ccf6","828":"b85ccc95","967":"c790336b","977":"601f4a36"}[chunkId] + ".chunk.js";
};